<svg [attr.width]="size" [attr.height]="size" viewBox="0 0 100 100" class="weather-icon-svg">

  <!-- SUN -->
  <g *ngIf="type === 'sun'">
    <circle cx="50" cy="50" r="20" fill="url(#sunGradient)" class="sun" />
    <g class="sun-rays">
      <line x1="50" y1="10" x2="50" y2="20" stroke="#FDB813" stroke-width="4" stroke-linecap="round" />
      <line x1="50" y1="80" x2="50" y2="90" stroke="#FDB813" stroke-width="4" stroke-linecap="round" />
      <line x1="10" y1="50" x2="20" y2="50" stroke="#FDB813" stroke-width="4" stroke-linecap="round" />
      <line x1="80" y1="50" x2="90" y2="50" stroke="#FDB813" stroke-width="4" stroke-linecap="round" />
      <line x1="22" y1="22" x2="29" y2="29" stroke="#FDB813" stroke-width="4" stroke-linecap="round" />
      <line x1="71" y1="71" x2="78" y2="78" stroke="#FDB813" stroke-width="4" stroke-linecap="round" />
      <line x1="22" y1="78" x2="29" y2="71" stroke="#FDB813" stroke-width="4" stroke-linecap="round" />
      <line x1="71" y1="29" x2="78" y2="22" stroke="#FDB813" stroke-width="4" stroke-linecap="round" />
    </g>
    <defs>
      <radialGradient id="sunGradient">
        <stop offset="0%" stop-color="#FFD700" />
        <stop offset="100%" stop-color="#FDB813" />
      </radialGradient>
    </defs>
  </g>

  <!-- CLOUD -->
  <g *ngIf="type === 'cloud' || type === 'partly-cloudy'">
    <g *ngIf="type === 'partly-cloudy'" transform="translate(-10, -10) scale(0.6)">
      <circle cx="50" cy="50" r="20" fill="#FDB813" class="sun" />
    </g>
    <path d="M25,60 a20,20 0 0,1 0,-40 a30,30 0 0,1 50,0 a20,20 0 0,1 0,40 z" fill="url(#cloudGradient)" class="cloud" />
    <defs>
      <linearGradient id="cloudGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stop-color="#ffffff" />
        <stop offset="100%" stop-color="#dbeafe" />
      </linearGradient>
    </defs>
  </g>

  <!-- RAIN -->
  <g *ngIf="type === 'rain'">
    <path d="M25,50 a20,20 0 0,1 0,-40 a30,30 0 0,1 50,0 a20,20 0 0,1 0,40 z" fill="#94a3b8" class="cloud-back" />
    <g class="rain-drops" transform="translate(30, 60)">
      <line x1="0" y1="0" x2="-5" y2="10" stroke="#0ea5e9" stroke-width="3" stroke-linecap="round" class="rain-drop" />
      <line x1="20" y1="5" x2="15" y2="15" stroke="#0ea5e9" stroke-width="3" stroke-linecap="round" class="rain-drop" />
      <line x1="40" y1="0" x2="35" y2="10" stroke="#0ea5e9" stroke-width="3" stroke-linecap="round" class="rain-drop" />
    </g>
  </g>

  <!-- STORM -->
  <g *ngIf="type === 'storm'">
    <path d="M25,50 a20,20 0 0,1 0,-40 a30,30 0 0,1 50,0 a20,20 0 0,1 0,40 z" fill="#475569" class="cloud" />
    <path d="M45,60 L35,80 L45,80 L40,100 L60,75 L50,75 L55,60 Z" fill="#FDB813" stroke="#eab308" stroke-width="1" class="lightning" />
  </g>

</svg>
